import i18next from 'i18next'
import React from 'react'
import { any, async, fromJSX, Updater, Widget } from 'widgets-for-react'
import { emptyImage } from '../../utils/image'
import { specialistsSrc, specialistsSrcSet } from '../../utils/imageSizes'
import { AZNavigationLayoutProps } from '../azNavigation/azNavigationLayout'
import { azNavigationWidget } from '../azNavigation/azNavigationWidget'
import { SpecialistPage } from '../cmsPage/cmsPageState'
import { SpecialistOverviewHeaderLayout, SpecialistOverviewSectionLayout } from './specialistOverviewLayout'
import {
  initialProcessedSpecialists,
  SpecialistOverviewState,
  specialistOverviewStateUpdaters,
} from './specialistOverviewState'
import { processSpecialistData } from './specialistOverviewUtils'

export const specialistOverviewWidget = (state: SpecialistOverviewState): Widget<Updater<SpecialistOverviewState>> => {

  const data = state.specialistsState.kind == "loaded" ? processSpecialistData(state.specialistsState.value, state.navigationState.filter, state.navigationState.filter2, state.navigationState.query) : initialProcessedSpecialists
  const paginationProps: AZNavigationLayoutProps = {
    title: i18next.t('misc:specialistOverviewPaginationTitle'),
    showFilter: true,
    enabledLetters: data.groups.map((g) => g.letter),
    filter: {
      allLabel: i18next.t('misc:allDepartments'),
      label: i18next.t('misc:specialistOverviewFilterDepartment'),
      options: data.departments.toArray().sort((a, b) => a.localeCompare(b)).map((department) => ({ key: department, title: department })),
    },
    filter2: {
      allLabel: i18next.t('misc:allRoles'),
      label: i18next.t('misc:specialistOverviewFilter2Role'),
      options: data.roles.toArray().sort((a, b) => a.localeCompare(b)).map((role) => ({ key: role, title: role })),
    },
    search: {
      kind: 'pagination-overview',
      label: i18next.t('misc:specialistOverviewFilterSearch'),
      placeholder: i18next.t('misc:specialistOverviewFilterSearchPlaceholder'),
    }
  }

  return any([
    async<SpecialistPage[]>(state.specialistsState).map(specialistOverviewStateUpdaters.updateSpecialistsState),
    fromJSX(() => (
      <SpecialistOverviewHeaderLayout
        department={state.navigationState.filter}
        breadcrumbs={[
          { title: 'Spaarne Gasthuis', url: '/' },
          { title: 'Specialisten', url: '/specialisten' },
        ]}
      />
    )),
    azNavigationWidget(paginationProps)(state.navigationState).map(specialistOverviewStateUpdaters.updateNavigationState),
    fromJSX(() => (
      <SpecialistOverviewSectionLayout
        specialists={data.groups.map((group) => ({
          ...group,
          items: group.items.map((item) => ({
            title: item.specialist?.title,
            role: item.specialist?.role,
            image: item.image || emptyImage,
            url: item.url,
          })),
        }))}
        imageOptions={{
          src: specialistsSrc,
          srcset: specialistsSrcSet,
          sizes: 'auto',
          lazyload: true,
          width: '253',
          height: '253',
          placeholder: '/images/placeholder--person.svg'
        }}
      />
    )),
  ])
}
